import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./layout.css";
import SideBarUserPreview from "../assets/assets_svg/sidebar-profile-preview.svg";
import SpeedoMeter from "../assets/assets_svg/speedometer.svg";
import Users from "../assets/assets_svg/users.svg";
import Adminer from "../assets/assets_svg/adminer.svg";
import Business from "../assets/assets_svg/business.svg";
import Relation from "../assets/assets_svg/relation.svg";
import Location from "../assets/assets_svg/location.svg";
import News from "../assets/assets_svg/news.svg";
import Ads from "../assets/assets_svg/ads.svg";
import Events from "../assets/assets_svg/event.svg";
import Deep from "../assets/assets_svg/deep.svg";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const [openMenus, setOpenMenus] = useState({});
  const admin = useSelector((state) => state?.auth?.user);
  console.log("🚀 ~ Sidebar ~ admin:", admin);

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  return (
    <>
      <div className="sidebar">
        <div className="sidebar-logo">Kharak Samaj</div>
        <div className="side-profile-icon-info text-center">
          <div className="profile-pic">
            <img src={SideBarUserPreview} alt="user-preview" />
          </div>
          <Link className="user-name">{admin?.fullname}</Link>
        </div>
        <div className="sidebar-menus">
          <ul className="menu-list">
            {admin?.is_superadmin ? (
              <li className={`menu-item`}>
                <Link to={"/dashboard"} className="menu-link">
                  <img src={SpeedoMeter} alt="speedometer icon" />
                  <p>Dashboard</p>
                </Link>
              </li>
            ) : (
              ""
            )}

            <li className="menu-item">
              <Link to={"/pending-members"} className="menu-link">
                <img src={Adminer} alt="surname icon" />
                <p>Pending Members</p>
              </Link>
            </li>

            {admin?.is_superadmin ? (
              <li className="menu-item">
                <Link to={"/members"} className="menu-link">
                  <img src={Users} alt="surname icon" />
                  <p>Members</p>
                </Link>
              </li>
            ) : (
              ""
            )}

            {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
              <li className="menu-item">
                <Link to={"/pending-sad-demise"} className="menu-link">
                  <img src={Deep} alt="surname icon" />
                  <p>Pending Sad Demise</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
              <li className="menu-item">
                <Link to={"/sad-demise"} className="menu-link">
                  <img src={Deep} alt="surname icon" />
                  <p>Sad Demise</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
              <li className="menu-item">
                <Link to={"/pending-news"} className="menu-link">
                  <img src={News} alt="surname icon" />
                  <p>Pending News</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
              <li className="menu-item">
                <Link to={"/live-news"} className="menu-link">
                  <img src={News} alt="surname icon" />
                  <p>Approved News</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
              <li className="menu-item">
                <Link to={"/ads"} className="menu-link">
                  <img src={Ads} alt="Ads icon" />
                  <p>Pending Ads</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
              <li className="menu-item">
                <Link to={"/live-ads"} className="menu-link">
                  <img src={Ads} alt="Ads icon" />
                  <p>Approve Ads</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
              <li className="menu-item">
                <Link to={"/pending-event"} className="menu-link">
                  <img src={Events} alt="event icon" />
                  <p>Pending Events</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin || admin?.id == 2 || admin?.id == 3 || admin?.id == 4 ? (
              <li className="menu-item">
                <Link to={"/live-event"} className="menu-link">
                  <img src={Events} alt="event icon" />
                  <p>Approve Events</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin ? (
              <li className="menu-item">
                <Link to={"/sub-admin"} className="menu-link">
                  <img src={Adminer} alt="sub admin icon" />
                  <p>Sub Admin</p>
                </Link>
              </li>
            ) : null}

            {admin?.is_superadmin ? (
              <li className="menu-item">
                <Link to={"/surname"} className="menu-link">
                  <img src={Users} alt="surname icon" />
                  <p>Surname</p>
                </Link>
              </li>
            ) : (
              ""
            )}
            {admin?.is_superadmin ? (
              <li className="menu-item">
                <Link to={"/villages"} className="menu-link">
                  <img src={Location} alt="village icon" />
                  <p>Villages</p>
                </Link>
              </li>
            ) : (
              ""
            )}
            {admin?.is_superadmin ? (
              <li className="menu-item">
                <Link to={"/relation"} className="menu-link">
                  <img src={Relation} alt="relation icon" />
                  <p>Relation</p>
                </Link>
              </li>
            ) : (
              ""
            )}
            {admin?.is_superadmin ? (
              <li className="menu-item">
                <Link to={"/business"} className="menu-link">
                  <img src={Business} alt="surname icon" />
                  <p>Business</p>
                </Link>
              </li>
            ) : (
              ""
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
